<mat-card>
  <mat-card-header>
    <mat-card-title>SKILLS & EXPERIENCE</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <form class="skills-form" [formGroup]="skillsForm">
      <div class="title" style="padding-bottom: 20px;">BAER IQCS Qualifications</div>
      <mat-checkbox formControlName="BAS">
        BAER Specialist - Fireline (BAS)
      </mat-checkbox>
      <mat-checkbox formControlName="BADO">
        BAER Documentation Specialist - Office (BADO)
      </mat-checkbox>
      <mat-checkbox formControlName="BAEL">
        BAER Team Leader (BAEL)
      </mat-checkbox>
      <div class="title" style="padding-bottom: 20px;">BAER Skills/Roles</div>
      <div class="small-title" style="padding-bottom: 20px;">Select your experience level for each role or skill, if
        any:
      </div>
      <br>
        <mat-form-field appearance="outline">
          <mat-label>Team Leader</mat-label>
          <mat-select formControlName="Team Leader">
            <mat-option value="-1">--</mat-option>
            @for (exp of exp_levels; track exp) {
              <mat-option [value]="exp.value">{{exp.text}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Arch/cultural/tribal</mat-label>
          <mat-select formControlName="Archaeology">
            <mat-option value="-1">--</mat-option>
            @for (exp of exp_levels; track exp) {
              <mat-option [value]="exp.value">{{exp.text}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Engineer/Roads</mat-label>
          <mat-select formControlName="Engineer">
            <mat-option value="-1">--</mat-option>
            @for (exp of exp_levels; track exp) {
              <mat-option [value]="exp.value">{{exp.text}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Fisheries (T&E)</mat-label>
          <mat-select formControlName="Fisheries">
            <mat-option value="-1">--</mat-option>
            @for (exp of exp_levels; track exp) {
              <mat-option [value]="exp.value">{{exp.text}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Geologist</mat-label>
          <mat-select formControlName="Geology">
            <mat-option value="-1">--</mat-option>
            @for (exp of exp_levels; track exp) {
              <mat-option [value]="exp.value">{{exp.text}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>GIS Specialist</mat-label>
          <mat-select formControlName="GIS">
            <mat-option value="-1">--</mat-option>
            @for (exp of exp_levels; track exp) {
              <mat-option [value]="exp.value">{{exp.text}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Hydrologist</mat-label>
          <mat-select formControlName="Hydrologist">
            <mat-option value="-1">--</mat-option>
            @for (exp of exp_levels; track exp) {
              <mat-option [value]="exp.value">{{exp.text}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Interagency Coordination</mat-label>
          <mat-select formControlName="Interagency Coordinator">
            <mat-option value="-1">--</mat-option>
            @for (exp of exp_levels; track exp) {
              <mat-option [value]="exp.value">{{exp.text}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Botany/Invasive Species</mat-label>
          <mat-select formControlName="Invasive Species/Botany">
            <mat-option value="-1">--</mat-option>
            @for (exp of exp_levels; track exp) {
              <mat-option [value]="exp.value">{{exp.text}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Public Information Officer</mat-label>
          <mat-select formControlName="Public Information Officer">
            <mat-option value="-1">--</mat-option>
            @for (exp of exp_levels; track exp) {
              <mat-option [value]="exp.value">{{exp.text}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Recreation/Trails</mat-label>
          <mat-select formControlName="Recreation Specialist">
            <mat-option value="-1">--</mat-option>
            @for (exp of exp_levels; track exp) {
              <mat-option [value]="exp.value">{{exp.text}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Soil Scientist</mat-label>
          <mat-select formControlName="Soil Scientist">
            <mat-option value="-1">--</mat-option>
            @for (exp of exp_levels; track exp) {
              <mat-option [value]="exp.value">{{exp.text}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Wildlife (T&E)</mat-label>
          <mat-select formControlName="Wildlife Biologist">
            <mat-option value="-1">--</mat-option>
            @for (exp of exp_levels; track exp) {
              <mat-option [value]="exp.value">{{exp.text}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Implementation</mat-label>
          <mat-select formControlName="Implementation">
            <mat-option value="-1">--</mat-option>
            @for (exp of exp_levels; track exp) {
              <mat-option [value]="exp.value">{{exp.text}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <div class="title">Other<div class="sub-title">(Other skills and level of experience)</div>
      </div>
      <mat-form-field class="text-area" appearance="outline">
        <textarea matInput formControlName="skills_text" placeholder="Enter description"></textarea>
      </mat-form-field>

      <div class="bar">&nbsp;</div>

      <div class="title" style="padding-bottom: 20px;">Resource Advisors IQCS qualifications</div>
      <div class="small-title" style="padding-bottom: 20px;">Select your experience level for each IQCS qualification
      </div>
      <br>
        <mat-form-field appearance="outline">
          <mat-label>Resource Advisor (READ)</mat-label>
          <mat-select formControlName="Resource Advisor (READ)">
            <mat-option value="-1">--</mat-option>
            @for (exp of exp_levels; track exp) {
              <mat-option [value]="exp.value">{{exp.text}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Resource Advisor - Fireline (REAF)</mat-label>
          <mat-select formControlName="Resource Advisor - Fireline (REAF)">
            <mat-option value="-1">--</mat-option>
            @for (exp of exp_levels; track exp) {
              <mat-option [value]="exp.value">{{exp.text}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Resource Advisor - Lead (REAC)</mat-label>
          <mat-select formControlName="Resource Advisor - Lead (REAC)">
            <mat-option value="-1">--</mat-option>
            @for (exp of exp_levels; track exp) {
              <mat-option [value]="exp.value">{{exp.text}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Resource Advisor - Archaeologist (ARCH)</mat-label>
          <mat-select formControlName="Resource Advisor - Archaeologist (ARCH)">
            <mat-option value="-1">--</mat-option>
            @for (exp of exp_levels; track exp) {
              <mat-option [value]="exp.value">{{exp.text}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <div class="title" style="padding-bottom: 20px;">Resource Advisor Skills/Roles</div>
        <mat-checkbox formControlName="archaeology_heritage_tribal">
          Archaeology/Heritage/Tribal
        </mat-checkbox>
        <mat-checkbox formControlName="botany_invasives">
          Botany/Invasives
        </mat-checkbox>
        <mat-checkbox formControlName="lead_read">
          Lead READ
        </mat-checkbox>
        <mat-checkbox formControlName="roads_engineering">
          Roads/Engineering
        </mat-checkbox>
        <mat-checkbox formControlName="suppression_repair">
          Suppression Repair
        </mat-checkbox>
        <mat-checkbox formControlName="timber">
          Timber
        </mat-checkbox>
        <mat-checkbox formControlName="trails_recreation">
          Trails/Recreation
        </mat-checkbox>
        <mat-checkbox formControlName="watershed_fisheries_ais">
          Watershed/Fisheries/AIS
        </mat-checkbox>
        <mat-checkbox formControlName="wilderness">
          Wilderness
        </mat-checkbox>
        <mat-checkbox formControlName="wildlife">
          Wildlife
        </mat-checkbox>










        <div class="title">READ Notes<div class="sub-title">(Specialty area details)</div>
      </div>
      <mat-form-field class="text-area" appearance="outline">
        <textarea matInput formControlName="read_text" placeholder="Enter description"></textarea>
      </mat-form-field>

      <div class="bar">&nbsp;</div>

      <div class="title">Experience with large or complex fires<div class="sub-title">(150,000+ acres)</div>
    </div>
    <mat-radio-group formControlName="large_fire_exp">
      <mat-radio-button [value]="true" color="primary">Yes</mat-radio-button>
      <mat-radio-button [value]="false" color="primary">No</mat-radio-button>
    </mat-radio-group>
    <div style="margin-top: 20px; width: 100%;">
      <mat-form-field appearance="outline" style="width: 600px; max-width: 600px; margin-left: -5px;">
        <mat-label>GACC/Dispatch Unit</mat-label>
        <input #gacc matInput formControlName="GACC_dispatch_center_id" [matAutocomplete]="auto" (input)="filter()">
        <mat-autocomplete requireSelection #auto="matAutocomplete" [displayWith]="displayFn">
          @for (gacc of filtered_gaccList | async; track gacc) {
            <mat-option [value]="gacc">{{gacc.text}} - {{gacc.description}}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>
    <mat-form-field appearance="outline" style="width: 600px; max-width: 600px; margin-left: -5px;">
      <mat-label>IQCS Employee ID</mat-label>
      <input matInput formControlName="IQCS_employee_id">
    </mat-form-field>
    <div class="title">List other IQCS qualifications on your red card</div>
    <mat-form-field class="text-area" appearance="outline">
      <textarea matInput formControlName="red_card_qualifications" placeholder="Enter description"></textarea>
    </mat-form-field>
    <div class="title">List BAER Coordinator, Team Lead, or Lead Resource Advisor references</div>
    <mat-form-field class="text-area" appearance="outline">
      <textarea matInput formControlName="team_references" placeholder="Enter description"></textarea>
    </mat-form-field>
    <div class="title">Any additional comments</div>
    <mat-form-field class="text-area" appearance="outline">
      <textarea matInput formControlName="skills_add_comments" placeholder="Enter description"></textarea>
    </mat-form-field>

    @if (isAdmin) {
      <div class="inner_div">
        <div class="title">Certification</div>
        <div class="checkbox-list">
          <mat-checkbox formControlName="nis_baer">
            NIS-BAER
          </mat-checkbox>
          <mat-checkbox formControlName="vgis">
            VGIS
          </mat-checkbox>
        </div>
      </div>
    }
  </form>
</mat-card-content>
<mat-dialog-actions>
  <div class="button-row">
    <button class="usa-button" (click)="save()">Save</button>
    <button class="usa-button usa-button--secondary" (click)="cancel()">Cancel</button>
  </div>
</mat-dialog-actions>
</mat-card>